<template>
    <div class="reports-page">
        <!-- Header -->
        <div class="reports-page__header">
            <h1 class="reports-page__title">
                Reports
                <span class="reports-page__count">/ {{ filteredReports.length }} of {{ allReports.length }}</span>
            </h1>
        </div>

        <!-- Empty State -->
        <div v-if="filteredReports.length === 0" class="reports-page__empty">
            <p class="none-found">No Reports Found</p>
        </div>

        <!-- Report Cards Grid -->
        <div v-else class="reports-page__grid">
            <a 
                v-for="report in filteredReports" 
                :key="report.id"
                :href="report.prep_url"
                class="reports-page__card"
            >
                <div class="reports-page__card-content">
                    <h3 class="reports-page__card-title" :title="report.name">
                        {{ report.name }}
                    </h3>
                    <p class="reports-page__card-description">
                        {{ report.description }}
                    </p>
                    
                    <!-- Preview Image -->
                    <div class="reports-page__card-preview">
                        <img 
                            v-if="report.preview_image"
                            :src="report.preview_image" 
                            :alt="report.name"
                            class="reports-page__preview-image"
                        />
                        <div v-else class="reports-page__preview-placeholder">
                            <svg class="reports-page__preview-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                    </div>
                </div>
                
                <!-- Progress Bar -->
                <div class="reports-page__card-progress"></div>
            </a>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ReportsV1',

    props: {
        reportData: {
            type: [Array, Object],
            required: false,
            default: () => []
        },
        selectedCategory: {
            type: [String, Number],
            default: ''
        }
    },

    created() {
        this.$store.dispatch('loadReports');
    },

    mounted() {
        console.log('Reports component mounted', this.reportData);
        if (this.reportData && this.reportData.length) {
            this.$store.commit('updateReports', { type: 'all', items: this.reportData });
            this.$store.commit('updateReports', { type: 'filtered', items: this.reportData });
        }
    },

    computed: {
        ...mapState(['reports']),

        allReports() {
            // Use reportData prop if available, otherwise fall back to store
            if (this.reportData && this.reportData.length) {
                return this.reportData;
            }
            return this.reports.all || [];
        },

        filteredReports() {
            let reports = this.allReports;
            
            // Apply category filter
            if (this.selectedCategory) {
                reports = reports.filter(report => report.category_id === this.selectedCategory);
            }
            
            return reports;
        },

    }
};
</script>
